import { ButtonList, DropdownButton } from '@dixa/lib-shared-habla';
import { LanguageModel } from 'lib-knowledge-management-common/hooks/useManagementLanguages';
import { useState } from 'react';

import s from './localePicker.module.scss';
import { useAddTranslation } from './useLocales';

type AddLocaleButtonProps = {
  disabled: boolean;
  availableLanguages: LanguageModel[];
  addTranslation: ReturnType<typeof useAddTranslation>[0];
};

export const AddLocaleButton = ({
  disabled,
  availableLanguages,
  addTranslation,
}: AddLocaleButtonProps): JSX.Element => {
  const [menuOpen, setMenuOpen] = useState(false);

  const onAddTranslation = async (language: LanguageModel) => {
    setMenuOpen(false);
    await addTranslation(language.languageId);
  };

  return (
    <DropdownButton
      aria-disabled={disabled}
      allowEscClose
      noArrow
      buttonProps={{
        variant: 'tertiary',
        icon: 'plus',
        disabled,
      }}
      dropdownProps={{ closeOnBlur: true, className: s.dropdown }}
      show={menuOpen}
      onToggle={setMenuOpen}
      dropdown={
        <ButtonList className={s.addLocaleMenu}>
          {availableLanguages.map((language) => (
            <ButtonList.Item
              key={language.languageId}
              onClick={() => onAddTranslation(language)}
            >
              {language.description}
            </ButtonList.Item>
          ))}
        </ButtonList>
      }
    >
      Add language
    </DropdownButton>
  );
};
